<icc-list 
    (select)="selectSystem($event)"
    [selected]="systemId"
    itemTemplate="itemImgTitle"
    itemImgHeight="medium"
    (showInfo)="showInfo($event)"
    [items]='systems'>
</icc-list>